import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
// import Accordion from "./components/Accordion";

const faqs = [
  {
    question: "Kapan dan di mana acara musik ini akan diadakan?",
    answer:
      "Acara akan berlangsung pada 15 September 2025 di Lapangan Utama Kota.",
  },
  {
    question: "Apakah tiket bisa dibeli secara online?",
    answer:
      "Ya, tiket dapat dibeli melalui situs resmi kami atau aplikasi mitra penjualan tiket.",
  },
  {
    question: "Apakah ada batasan usia untuk penonton?",
    answer:
      "Acara ini terbuka untuk semua usia, namun anak di bawah 12 tahun harus didampingi orang tua.",
  },
];

function App() {
  return (
    <div>
      <Accordion data={faqs} />
      <Footer />
    </div>
  );
}

function Accordion({ data }) {
  const [curOpen, setIsOpen] = useState(null);

  return (
    <div className="accordion">
      {data.map((faq, index) => (
        <AccordionItem
          number={index + 1}
          curOpen={curOpen}
          onOpen={setIsOpen}
          question={faq.question}
          answer={faq.answer}
          key={index}
        />
      ))}
    </div>
  );
}

function AccordionItem({ number, question, answer, curOpen, onOpen }) {
  const isOpen = number === curOpen;

  function handleToggle() {
    onOpen(isOpen ? null : number);
  }
  return (
    <motion.div
      className={`item ${isOpen ? "open" : ""}`}
      onClick={handleToggle}
      whileHover={{ scale: 1.02 }}
      transition={{ type: "spring", stiffness: 200 }}
    >
      <p className="number">{number < 10 ? `0${number}` : number}</p>
      <p className="title">{question}</p>
      <p className="icon">{isOpen ? "-" : "+"}</p>

      {/* Animasi konten pakai AnimatePresence */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="content-box"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
          >
            {answer}
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}

function Footer() {
  return (
    <motion.div
      className="footer"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
    >
      <p>&copy; 2025. Gilang Abdian. Based on Codepolitan Case Study.</p>
    </motion.div>
  );
}

export default App;
